import { createFileRoute, Link } from "@tanstack/react-router";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { ArrowLeft, Activity } from "lucide-react";

export const Route = createFileRoute("/admin/siem/infrastructure/kubernetes/")({
  component: Page,
});

function Page() {
  return (
    <div className="space-y-4 p-6">
      <Link to="/admin/siem" className="inline-flex items-center gap-1 text-sm text-muted-foreground hover:text-foreground">
        <ArrowLeft className="h-3 w-3" /> Dashboard SIEM
      </Link>
      <div>
        <div className="flex items-center gap-2 mb-1">
          <Badge variant="destructive" className="text-[10px]">SUPERADMIN</Badge>
        </div>
        <h1 className="text-2xl font-bold tracking-tight">Kubernetes</h1>
        <p className="mt-1 text-sm text-muted-foreground">Pods · Services · Ingress · HPA · ArgoCD</p>
      </div>
      <div className="grid grid-cols-2 gap-3 md:grid-cols-4">
        <Card><CardContent className="p-4"><div className="text-xs uppercase text-muted-foreground">Clusters</div><div className="mt-1 text-2xl font-bold text-emerald-400">3</div></CardContent></Card>
        <Card><CardContent className="p-4"><div className="text-xs uppercase text-muted-foreground">Pods running</div><div className="mt-1 text-2xl font-bold text-emerald-400">184</div></CardContent></Card>
        <Card><CardContent className="p-4"><div className="text-xs uppercase text-muted-foreground">CPU usage</div><div className="mt-1 text-2xl font-bold text-emerald-400">42%</div></CardContent></Card>
        <Card><CardContent className="p-4"><div className="text-xs uppercase text-muted-foreground">Memory</div><div className="mt-1 text-2xl font-bold text-emerald-400">67%</div></CardContent></Card>
      </div>
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Activity className="h-4 w-4" />
            Détails Kubernetes
          </CardTitle>
          <CardDescription>Module opérationnel · branché à l'API unifiée v7.1</CardDescription>
        </CardHeader>
        <CardContent className="text-sm text-muted-foreground">
          <p>Page détaillée du module Kubernetes. Les métriques sont collectées via OpenTelemetry et agrégées via Prometheus.</p>
        </CardContent>
      </Card>
    </div>
  );
}
